import { useState } from "react";
import type { ComplianceQuestion } from "newui/features/Rfx/Evaluation/types/compliance";
import {
	SupplierComplianceAccordionItem,
	type SupplierMeta,
} from "./SupplierComplianceAccordionItem";

interface SupplierComplianceAccordionProps {
	questions: ComplianceQuestion[];
	suppliers: SupplierMeta[];
	locked: boolean;
}

export const SupplierComplianceAccordion = ({ questions, suppliers, locked }: SupplierComplianceAccordionProps) => {
	// Single-expand (like the panel MemberScoreAccordion) keeps at most one heavy
	// comment editor mounted. Auto-open when there is only one supplier.
	const [expandedIndex, setExpandedIndex] = useState<number | null>(
		suppliers.length === 1 ? 0 : null
	);

	return (
		<div
			className="space-y-2"
			role="group"
			aria-label="Supplier compliance"
			data-testid="compliance-supplier-accordion"
		>
			{suppliers.map((supplier, sIdx) => (
				<SupplierComplianceAccordionItem
					key={supplier.invite_id}
					supplier={supplier}
					questions={questions}
					supplierIndex={sIdx}
					locked={locked}
					isExpanded={expandedIndex === sIdx}
					onToggle={() =>
						setExpandedIndex((prev) => (prev === sIdx ? null : sIdx))
					}
				/>
			))}
		</div>
	);
};
